"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const foundation_settings_1 = require("@episerver/foundation-settings");
const react_1 = __importStar(require("react"));
const spa_core_1 = require("@episerver/spa-core");
const react_helmet_1 = require("react-helmet");
const Tab_1 = __importDefault(require("react-bootstrap/Tab"));
const Tabs_1 = __importDefault(require("react-bootstrap/Tabs"));
const LoadingSpinner_1 = __importDefault(require("../Shared/LoadingSpinner"));
const PageImage_1 = __importDefault(require("../Common/Pageimage/PageImage"));
const EventList_1 = __importDefault(require("../Common/EventList/EventList"));
const PageTop_1 = __importDefault(require("app/Components/Shared/PageTop"));
const Glossary_1 = __importDefault(require("app/Components/Shared/Glossary"));
const react_redux_1 = require("react-redux");
const Button_1 = __importStar(require("app/Components/Common/Button"));
const TabFunctions_1 = require("app/Components/Common/TabFunctions");
require("./EventsPage.scss");
const getFilterCategories = (l, filterCategories, allCategories) => {
    const categories = [];
    if (allCategories && allCategories.categories && Boolean(allCategories.categories.find)) {
        filterCategories.forEach(filter => {
            categories.push(allCategories.categories.find(category => category.id === filter.id.toString()));
        });
    }
    return categories;
};
const DefaultEventsPage = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    const { data, currentLanguage } = props;
    const settingsService = (0, foundation_settings_1.useSettings)();
    const api = (0, spa_core_1.useContentDeliveryAPI)();
    const ctx = (0, spa_core_1.useEpiserver)();
    const SSR = ctx.isServerSideRendering();
    const [events, setEvents] = (0, react_1.useState)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [selectedTabKey, setSelectedTabKey] = (0, react_1.useState)('all');
    const filters = Array.from((((_a = props.data.filterCategories) === null || _a === void 0 ? void 0 : _a.value) ? props.data.filterCategories.value : []));
    const [categoryList, setCategoryList] = (0, react_1.useState)(getFilterCategories(props.currentLanguage, filters, settingsService.getContainerOnServer('Categories')));
    const [labelSettings, setLabelSettings] = (0, react_1.useState)(settingsService.getContainerOnServer('LabelSettings'));
    const [layoutSettings, setLayoutSettings] = (0, react_1.useState)(settingsService.getContainerOnServer('LayoutSettings'));
    const [isTabsOpen, setIsTabsOpen] = (0, react_1.useState)(false);
    const [isInitialLoad, setIsInitialLoad] = (0, react_1.useState)(true);
    const filterDate = new Date();
    filterDate.setHours(0, 0, 0, 0);
    filterDate.setDate(1);
    filterDate.setMonth(0);
    const filterString = `ContentType/any(t:t eq \'EventPage\') and eventDateTime/value ge ${filterDate.toISOString()}`;
    const sortOrder = 'eventDateTime/value desc';
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    const getTabTitle = (texts) => {
        const title = texts.find(item => item.language === currentLanguage).displayText;
        if (Boolean(title)) {
            return title;
        }
        const titleInAnyLang = texts.find(item => (item.displayText && item.displayText.length > 0)).displayText;
        // If the category does not have a title set for current language, use any title present.
        // If selected category does not have any title set return generic Tab.
        return titleInAnyLang || 'Tab';
    };
    const getUpcomingEvents = () => {
        const eventslist = events.filter((event) => {
            const eventDateWithoutHours = new Date(event.eventDateTime.value);
            eventDateWithoutHours.setHours(0, 0, 0, 0);
            return eventDateWithoutHours >= currentDate;
        });
        if (eventslist && eventslist.length > 0) {
            eventslist.sort(function (a, b) {
                var _a, _b;
                try {
                    if (((_a = a.eventDateTime) === null || _a === void 0 ? void 0 : _a.value) && new Date(a.eventDateTime.value) < new Date(b.eventDateTime.value)) {
                        return -1;
                    }
                    if (((_b = a.eventDateTime) === null || _b === void 0 ? void 0 : _b.value) && new Date(a.eventDateTime.value) > new Date(b.eventDateTime.value)) {
                        return 1;
                    }
                    return 0;
                }
                catch (_c) {
                    //ignore on purpose
                }
            });
        }
        return eventslist;
    };
    const getPastEvents = () => (events.filter((event) => {
        const eventDateWithoutHours = new Date(event.eventDateTime.value);
        eventDateWithoutHours.setHours(0, 0, 0, 0);
        return eventDateWithoutHours < currentDate;
    }));
    const fetchEventsForCategory = (categoryId) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const filter = categoryId === 'all' ? filterString : `${filterString} and (categories/value/id eq ${categoryId}) and eventDateTime/value ge ${filterDate.toISOString()}`;
            const fetchResult = yield api.basicSearch('', filter, sortOrder, undefined, undefined, false);
            return fetchResult.results;
        }
        catch (error) {
            console.error('Error occurred fetching the events', error);
        }
    });
    const searchCategoryName = (id) => {
        if (!id || id === '')
            return '';
        if (id === 'all')
            return props.data.allEventsLabel.value;
        const category = categoryList.find((cat) => cat.id === id);
        return getTabTitle(category.displayTexts);
    };
    const selectTab = (key) => {
        setSelectedTabKey(key);
        (0, TabFunctions_1.toggleTabs)('tabnav', setIsTabsOpen);
    };
    const linkKeyDown = (e) => {
        const event = e;
        if (event.code === 'ArrowDown' || event.code === 'ArrowUp')
            e.stopPropagation();
    };
    (0, react_1.useEffect)(() => {
        var _a;
        let componentMounted = true;
        if (currentLanguage && ((_a = layoutSettings === null || layoutSettings === void 0 ? void 0 : layoutSettings.language) === null || _a === void 0 ? void 0 : _a.name) !== currentLanguage) {
            Promise.allSettled([
                settingsService.getContainer('LayoutSettings'),
                settingsService.getContainer('LabelSettings'),
                settingsService.getContainer('Categories')
            ]).then((results) => {
                if (componentMounted) {
                    results[0].status === 'fulfilled' && setLayoutSettings(results[0].value);
                    results[1].status === 'fulfilled' && setLabelSettings(results[1].value);
                    results[2].status === 'fulfilled' && setCategoryList(getFilterCategories(props.currentLanguage, filters, results[2].value));
                }
            });
        }
        setLoading(true);
        fetchEventsForCategory(selectedTabKey).then(res => {
            if (componentMounted)
                setEvents(res);
        }).finally(() => {
            setLoading(false);
            if (isInitialLoad)
                setIsInitialLoad(false);
        });
        document.querySelectorAll('.nav-link').forEach(link => {
            link.addEventListener('keydown', (e) => linkKeyDown(e));
        });
        return () => {
            componentMounted = false;
            document.querySelectorAll('.nav-link').forEach(link => {
                link.removeEventListener('keydown', (e) => linkKeyDown(e));
            });
        };
    }, [currentLanguage]);
    (0, react_1.useEffect)(() => {
        if (!isInitialLoad) {
            let componentMounted = true;
            setLoading(true);
            fetchEventsForCategory(selectedTabKey).then(res => {
                if (componentMounted)
                    setEvents(res);
            }).finally(() => setLoading(false));
            return () => {
                componentMounted = false;
            };
        }
    }, [selectedTabKey]);
    (0, react_1.useEffect)(() => {
        const tabnav = document.querySelector('[role=tablist]');
        if (tabnav)
            tabnav.setAttribute('id', 'tabnav');
    }, [events]);
    (0, react_1.useEffect)(() => {
        if (!ctx.isInEditMode() && document.activeElement.id !== 'contentRow')
            document.querySelector('h1').focus({ preventScroll: true });
    }, [props.contentLink.id]);
    if (!layoutSettings || !labelSettings || !categoryList)
        return react_1.default.createElement(LoadingSpinner_1.default, null);
    const companyDesc = ((_b = layoutSettings.companyDesc) === null || _b === void 0 ? void 0 : _b.value) ? (_c = layoutSettings.companyDesc) === null || _c === void 0 ? void 0 : _c.value : layoutSettings.companyDesc;
    const langtags = [];
    ((_d = props.data.existingLanguages) === null || _d === void 0 ? void 0 : _d.length) > 1 &&
        props.data.existingLanguages.forEach(l => {
            langtags.push(react_1.default.createElement("link", { href: l.link, hrefLang: l.name, rel: "alternate", key: l.name }));
        });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.Helmet, null,
            react_1.default.createElement("title", null, `${data.metaTitle.value || data.mainHeading.value}`),
            react_1.default.createElement("link", { rel: "canonical", href: ((_e = props.data.canonicalUrl) === null || _e === void 0 ? void 0 : _e.value) ? `${ctx.getEpiserverURL()}${props.data.canonicalUrl.value}` : props.data.url }),
            ((_f = props.data.keywords) === null || _f === void 0 ? void 0 : _f.value) &&
                react_1.default.createElement("meta", { name: "keywords", content: props.data.keywords.value }),
            react_1.default.createElement("meta", { name: "description", content: ((_h = (_g = props.data) === null || _g === void 0 ? void 0 : _g.pageDescription) === null || _h === void 0 ? void 0 : _h.value) || companyDesc }),
            react_1.default.createElement("meta", { property: "og:url", content: window.location.href }),
            react_1.default.createElement("meta", { property: "og:type", content: ((_j = props.data.metaContentType) === null || _j === void 0 ? void 0 : _j.value) || 'website' }),
            react_1.default.createElement("meta", { property: "og:title", content: `${data.metaTitle.value || data.mainHeading.value}` }),
            react_1.default.createElement("meta", { property: "og:description", content: ((_l = (_k = props.data) === null || _k === void 0 ? void 0 : _k.pageDescription) === null || _l === void 0 ? void 0 : _l.value) || companyDesc }),
            ((_o = (_m = layoutSettings.facebookShareImage) === null || _m === void 0 ? void 0 : _m.value) === null || _o === void 0 ? void 0 : _o.url) &&
                react_1.default.createElement("meta", { property: "og:image", content: layoutSettings.facebookShareImage.value.url }),
            ((_q = (_p = layoutSettings.twitterShareImage) === null || _p === void 0 ? void 0 : _p.value) === null || _q === void 0 ? void 0 : _q.url) &&
                react_1.default.createElement("meta", { property: "twitter:image", content: layoutSettings.twitterShareImage.value.url }),
            react_1.default.createElement("meta", { name: "twitter:card", content: "summary" }),
            ((_r = props.data.existingLanguages) === null || _r === void 0 ? void 0 : _r.length) > 1 &&
                react_1.default.createElement("link", { href: props.data.url, hrefLang: "x-default", rel: "alternate" }),
            ((_s = props.data.existingLanguages) === null || _s === void 0 ? void 0 : _s.length) > 1 && langtags,
            ((_t = props.data.jsonLdSchema) === null || _t === void 0 ? void 0 : _t.value) && props.data.jsonLdSchema.value.trim() !== '' &&
                react_1.default.createElement("script", { type: "application/ld+json" }, props.data.jsonLdSchema.value)),
        react_1.default.createElement("main", { role: 'main', className: "page position-relative events-page", tabIndex: -1 },
            react_1.default.createElement(PageTop_1.default, { layoutSettings: layoutSettings, showNews: data.showPageTopNews.value, breadCrumbsProps: data, fontWhite: data.isPageTopFontWhite.value, lang: currentLanguage }),
            react_1.default.createElement(Glossary_1.default, { labelSettings: labelSettings, useGlossary: data.useGlossary.value, useShare: data.useShare.value }),
            react_1.default.createElement(PageImage_1.default, { classNames: "d-none d-sm-block", imageData: data.pageImage, layoutSettings: layoutSettings, tickerBgColorClass: (_u = props.data.shareTickerBackground) === null || _u === void 0 ? void 0 : _u.value, showTickerOnMobile: false }),
            react_1.default.createElement("div", { className: "position-relative content-padding mb-10" },
                react_1.default.createElement("div", { className: "events-top-container heading-section" },
                    react_1.default.createElement("h1", { className: 'no-outline', tabIndex: -1 },
                        react_1.default.createElement(spa_core_1.Components.Property, { iContent: data, field: "mainHeading" })),
                    react_1.default.createElement("div", { className: 'position-relative mt-sm-10' },
                        react_1.default.createElement("div", { className: 'd-block d-sm-none tab-button mt-9' },
                            react_1.default.createElement(Button_1.default, { type: Button_1.ButtonType.Outline, iconClass: 'icon-arrow-right-tail', onClick: () => (0, TabFunctions_1.toggleTabs)('tabnav', setIsTabsOpen), ariacontrols: 'tabnav', ariaexpanded: isTabsOpen, title: searchCategoryName(selectedTabKey) })),
                        react_1.default.createElement(Tabs_1.default, { id: "events-tabs", className: "mb-3 events-tabs", activeKey: selectedTabKey, onSelect: (key) => selectTab(key) },
                            react_1.default.createElement(Tab_1.default, { eventKey: "all", title: ((_v = data.allEventsLabel) === null || _v === void 0 ? void 0 : _v.value) || 'All' },
                                react_1.default.createElement("div", { className: "events-tab-container mt-10" },
                                    loading && react_1.default.createElement(LoadingSpinner_1.default, null),
                                    !loading && events && (react_1.default.createElement(react_1.default.Fragment, null,
                                        react_1.default.createElement("h2", { className: "mb-5" },
                                            react_1.default.createElement(spa_core_1.Components.Property, { iContent: data, field: "upcomingEventsHeading" })),
                                        react_1.default.createElement(EventList_1.default, { events: getUpcomingEvents(), noEventsText: (_w = data.noEventsText) === null || _w === void 0 ? void 0 : _w.value }),
                                        react_1.default.createElement("h2", { className: "mt-10 mb-5" },
                                            react_1.default.createElement(spa_core_1.Components.Property, { iContent: data, field: "pastEventsHeading" })),
                                        react_1.default.createElement(EventList_1.default, { events: getPastEvents(), noEventsText: (_x = data.noEventsText) === null || _x === void 0 ? void 0 : _x.value }))))),
                            !SSR && categoryList && categoryList.map((category) => {
                                var _a, _b;
                                return (react_1.default.createElement(Tab_1.default, { key: category.id, eventKey: category.id, title: getTabTitle(category.displayTexts) },
                                    react_1.default.createElement("div", { className: "events-tab-container mt-10" },
                                        loading && react_1.default.createElement(LoadingSpinner_1.default, null),
                                        (!loading && events && category.id === selectedTabKey) && (react_1.default.createElement(react_1.default.Fragment, null,
                                            react_1.default.createElement("h2", { className: "mb-5 no-outline", tabIndex: -1 },
                                                react_1.default.createElement(spa_core_1.Components.Property, { iContent: data, field: "upcomingEventsHeading" })),
                                            react_1.default.createElement(EventList_1.default, { events: getUpcomingEvents(), noEventsText: (_a = data.noEventsText) === null || _a === void 0 ? void 0 : _a.value }),
                                            react_1.default.createElement("h2", { className: "mt-10 mb-5" },
                                                react_1.default.createElement(spa_core_1.Components.Property, { iContent: data, field: "pastEventsHeading" })),
                                            react_1.default.createElement(EventList_1.default, { events: getPastEvents(), noEventsText: (_b = data.noEventsText) === null || _b === void 0 ? void 0 : _b.value }))))));
                            })))),
                react_1.default.createElement(spa_core_1.Components.ContentArea, { data: data.bottomContentArea })))));
};
const ConnectedEventsPage = (0, react_redux_1.connect)((state, ownProps) => {
    const propsFromState = state.OptiContentCloud || {};
    const propsFromAppState = state.ApplicationStates || {};
    return Object.assign(Object.assign(Object.assign({}, ownProps), propsFromState), propsFromAppState);
})(DefaultEventsPage);
const EventsPage = (props) => {
    const ctx = (0, spa_core_1.useEpiserver)();
    return ctx.isServerSideRendering() ? react_1.default.createElement(DefaultEventsPage, Object.assign({}, props)) : react_1.default.createElement(ConnectedEventsPage, Object.assign({}, props));
};
exports.default = EventsPage;
